<template>
  <login-layout title="회원가입 신청">
    <v-text-field
        v-model="id" label="아이디(모집인번호)" outlined
        :rules="[ value => !regExp.test(value) || '영문 및 숫자만 입력 가능합니다.' ]"
        prepend-icon="mdi-account"
    />
    <v-text-field
        type="password"
        v-model="password" label="비밀번호" outlined
        prepend-icon="mdi-lock"
    />
    <v-text-field
        type="password"
        v-model="password" label="비밀번호 확인" outlined
        prepend-icon="mdi-lock-check"
    />
    <v-select
        v-model="team" label="팀"
        :items="teamList" item-text="teamNm" item-value="team"
        outlined prepend-icon="mdi-account-group"
    />
    <v-text-field
        v-model="email" label="이메일" outlined
        prepend-icon="mdi-email"
    />
    <v-text-field
        v-model="telNum" label="전화번호" outlined
        @keypress.enter="valid && login()"
        prepend-icon="mdi-phone"
    />
  </login-layout>
</template>

<script>
import {axiosInstance} from "@/util/AxiosModule";
import router from "@/router";
import LoginLayout from "@/pages/Login/layout/LoginLayout.vue";

export default {
  name: "Signup",
  components: {LoginLayout},
  data() {
    return {
      valid: false,
      id: "",
      password: "",
      team: "",
      teamList: [
        { teamNm: "Team1", team: "t1" },
        { teamNm: "Team2", team: "t2" },
        { teamNm: "Team3", team: "t3" }
      ],
      email: "",
      telNum: "",
      regExp: /[^a-zA-Z0-9]/g,
    }
  },
  methods: {
    async login() {
      const loginDto = {
        site: this.site,
        id: this.id,
        password: this.password
      };

      try {
        const { data } = await axiosInstance.post(`/public/login`, loginDto);
        let role = data.memberRole;

        if (role === 'ADMIN' || role === 'MANAGER') {
          await this.$store.dispatch('login/login', data, {root: true});
          await router.push({name: "IimsUploadPage"});
        } else {
          alert("권한자만 접근할 수 있습니다.");
        }
      } catch (error) {
        await this.showAlert({message: `${error}`})
      }
    },
    goBack() {
      this.$router.go(-1); // 이전 페이지로 이동
    }
  }
}
</script>

<style lang="scss" scoped>
.container-layout {
  max-width: 600px;
  .main-layout {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .previous-page {
      width: 100%;
      padding: 20px 0;
      display: flex;
      justify-content: flex-start;
      span {
        font-weight: bold;
      }
      span:hover {
        color: #1772C7;
        cursor: pointer;
      }
    }
    .logo-layout {
      display: flex;
      justify-content: center;
      align-items: center;
      .logo-image {
        width: 200px;
      }
    }
    .card-layout {
      margin: 0 auto;
      width: 350px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      box-shadow: none;
      .card-title {
        font-weight: bolder;
        font-size: 1.5em;
        color: darkblue;
        justify-content: center;
        margin-bottom: 50px;
      }
    }
  }
}

.button {
  cursor: pointer;
}
.button:hover {
  color: #1772C7;
}
</style>